import { render, staticRenderFns } from "./LabelPreviewImage.vue?vue&type=template&id=aeec34e8&scoped=true"
import script from "./LabelPreviewImage.vue?vue&type=script&setup=true&lang=ts"
export * from "./LabelPreviewImage.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./LabelPreviewImage.vue?vue&type=style&index=0&id=aeec34e8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aeec34e8",
  null
  
)

export default component.exports